export default __webpack_public_path__ + "static/media/user.2161e81f.svg";